const cartForm = document.getElementById("cart");
const containerEnoughValue = document.querySelector(".conatiner-enough-value");
const containerTooLittleValue = document.querySelector(".conatiner-too-little-value");
const missingMoneySpan = document.querySelector(".missing-money")
const wrapper = document.querySelector(".missing-order-value-wrapper")
const minOrderValue = parseInt(wrapper.getAttribute("data-min-value"), 10);

fetchCart().then(handleCartUpdate)

if (cartForm) {
    const observer = new MutationObserver(()=> {
        fetchCart().then(handleCartUpdate);
    });

    observer.observe(cartForm, { childList: true, subtree: true });
}

function updateCartMessages(itemCount) {
    if (itemCount > 0) document.documentElement.style.setProperty("--cart__custom-messages-display", "block");
    else document.documentElement.style.setProperty("--cart__custom-messages-display", "none");
}

async function fetchCart() {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        return cart;
    } catch (error) {
        console.log(error)
        return null;
    } 
}

function handleCartUpdate(cart) {
    if (!cart) return;
    updateCartMessages(cart.item_count);
    if (cart.total_price === 0) document.documentElement.style.setProperty("--cart__missing-oder-calue-text-align", "center");
    else document.documentElement.style.setProperty("--cart__missing-oder-calue-text-align", "left");
    if (cart.total_price >= minOrderValue) cartValueIsEnough();
    else cartValueIsToLittle(cart.total_price);
}

function cartValueIsEnough() {
  containerEnoughValue.style.display = "block";
  containerTooLittleValue.style.display = "none";
}

function cartValueIsToLittle(cartValue) {
  containerEnoughValue.style.display = "none";
  containerTooLittleValue.style.display = "block";
  const missingCents = minOrderValue - cartValue;
  const formattedMoney = new Intl.NumberFormat('de-DE', { 
    style: 'currency', 
    currency: 'EUR' 
  }).format(missingCents / 100);
  missingMoneySpan.textContent = formattedMoney;
}